import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import CategorySection from './components/CategorySection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '6080新视觉影院',
    url: typeof window !== 'undefined' ? window.location.origin : '',
    description: '6080新视觉影院提供高清电影免费在线观看，最新电影电视剧全集不卡顿流畅播放，极速秒开不缓冲，免费看大片。',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: typeof window !== 'undefined' ? `${window.location.origin}/category/{search_term}` : '',
      },
      'query-input': 'required name=search_term',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '6080新视觉影院',
    url: typeof window !== 'undefined' ? window.location.origin : '',
    description: '6080新视觉影院 - 免费高清电影在线观看平台',
    sameAs: [],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturedSection />
          <CategorySection />
          <RankingSection />
          <FeaturesSection />
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
}